import config from 'shared/config/config';
// import { Braze } from 'shared/services/Braze';
import { trackEvent as trackGAEvent } from 'shared/services/GoogleAnalytics';

import {
  ANALYTICS_EVENTS_URL
} from 'shared/utils/Constants';

import {
  post
} from 'shared/services/ApiService';

export const trackEvent = (event, attrs = {}) => {
  attrs.requestId = generateRequestId(24);

  if (config.env === 'production') {
    new Promise(() => trackGAEvent(event, attrs));
  }

  // new Promise(() => Braze.logCustomEvent(event, attrs));

  // also track internally    
  post(ANALYTICS_EVENTS_URL, {
    request_id: attrs && attrs.requestId,
    event: event,
    attrs: attrs
  });
}

function generateRequestId(length) {
    var result           = [];
    var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var charactersLength = characters.length;
    for ( var i = 0; i < length; i++ ) {
      result.push(characters.charAt(Math.floor(Math.random() * 
 charactersLength)));
   }
   return result.join('');
}
